const bankRequiredMethods = [
  'transfer_deposit',
  'direct_debit',
  'transfer_debit',
  'transfer_subsidy',
];

const paymentCustomerSelectLanguage = {
  inputTooShort: function () {
    return '1文字以上入力してください。';
  },
  searching: function () {
    return '検索中...';
  },
  noResults: function () {
    return '見つかりません。';
  },
};

const selectedPaymentItems = new Map();
let paymentSelectionScope = 'page';

const showPaymentError = (message) => {
  if (window.Swal) {
    window.Swal.fire({ icon: 'warning', text: message });
    return;
  }

  window.alert(message);
};

const formatYen = (value) => `￥${Number(value || 0).toLocaleString('ja-JP')}`;

const toHalfWidthDigits = (value) =>
  String(value == null ? '' : value).replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0));

const amountDigits = (value) => toHalfWidthDigits(value).replace(/[^\d]/g, '');

const parseAmount = (value) => {
  const digits = amountDigits(value);
  return digits === '' ? 0 : Number(digits);
};

const formatAmount = (value) => {
  const digits = amountDigits(value);
  return digits === '' ? '' : Number(digits).toLocaleString('ja-JP');
};

const restoreAmountCaret = (input, previousValue, previousCaret, formattedValue) => {
  const digitsBeforeCaret = amountDigits(String(previousValue).slice(0, previousCaret || 0)).length;
  if (digitsBeforeCaret === 0) {
    input.setSelectionRange(0, 0);
    return;
  }

  let seenDigits = 0;
  for (let index = 0; index < formattedValue.length; index += 1) {
    if (/\d/.test(formattedValue[index])) {
      seenDigits += 1;
      if (seenDigits === digitsBeforeCaret) {
        input.setSelectionRange(index + 1, index + 1);
        return;
      }
    }
  }

  input.setSelectionRange(formattedValue.length, formattedValue.length);
};

const updateAmountValidity = (input, amount) => {
  const maxAmount = Number($(input).attr('data-max') || 0);
  if ($(input).val() === '' || amount < 1) {
    input.setCustomValidity('入金額は1円以上で入力してください。');
  } else if (maxAmount > 0 && amount > maxAmount) {
    input.setCustomValidity('入金額が未入金額を超えています。');
  } else {
    input.setCustomValidity('');
  }
};

const rowPaymentItem = ($row) => ({
  id: String($row.attr('data-bill-sheet-id') || ''),
  billNo: String($row.attr('data-bill-no') || ''),
  customer: String($row.attr('data-customer') || ''),
  project: String($row.attr('data-project') || ''),
  outstandingAmount: Number($row.attr('data-outstanding') || 0),
  billPayMethod: String($row.attr('data-bill-pay-method') || ''),
  billPayMethodLabel: String($row.attr('data-bill-pay-method-label') || ''),
  bankAccountId: String($row.attr('data-bank-account-id') || ''),
  bankAccountName: String($row.attr('data-bank-account-name') || ''),
  mainCompanyId: String($row.attr('data-main-company-id') || ''),
});

const normalizeSelectionItem = (item) => ({
  id: String(item.id || ''),
  billNo: String(item.bill_no || ''),
  customer: String(item.customer || ''),
  project: String(item.project || ''),
  outstandingAmount: Number(item.outstanding_amount || 0),
  billPayMethod: String(item.bill_pay_method || ''),
  billPayMethodLabel: String(item.bill_pay_method_label || ''),
  bankAccountId: String(item.bank_account_id || ''),
  bankAccountName: String(item.bank_account_name || ''),
  mainCompanyId: String(item.main_company_id || ''),
});

const syncVisiblePaymentCheckboxes = () => {
  $('.payment-bill-checkbox').each(function () {
    const id = String($(this).val());
    $(this).prop('checked', selectedPaymentItems.has(id));
  });

  const $visible = $('.payment-bill-checkbox:not(:disabled)');
  $('#payment_check_all').prop(
    'checked',
    $visible.length > 0 && $visible.filter(':checked').length === $visible.length,
  );
};

const updatePaymentSelectionUI = () => {
  const selectedCount = selectedPaymentItems.size;
  const registerableCount = Number(
    $('#payment-selection-scope').attr('data-registerable-count') || 0,
  );

  $('#payment-selected-count').text(selectedCount);
  $('#payment-selection-count').toggleClass('d-none', selectedCount === 0);
  $('#payment-selection-scope').toggleClass('d-none', selectedCount === 0);
  $('#select-all-filtered-payments').toggleClass(
    'd-none',
    paymentSelectionScope === 'filtered' || registerableCount <= selectedCount,
  );
  syncVisiblePaymentCheckboxes();
};

const clearPaymentSelection = () => {
  selectedPaymentItems.clear();
  paymentSelectionScope = 'page';
  updatePaymentSelectionUI();
};

const syncPaymentOperationColumn = ($container) => {
  const container = $container.get(0);
  if (!container) return;

  const remainingScroll = Math.max(
    0,
    container.scrollWidth - container.clientWidth - container.scrollLeft,
  );
  $container
    .find('.payment-operation-column')
    .css('transform', `translateX(${-remainingScroll}px)`);
};

const initializePaymentOperationColumn = () => {
  $('.payment-list-card .table-responsive').each(function () {
    const $container = $(this);
    $container
      .off('scroll.paymentOperationColumn')
      .on('scroll.paymentOperationColumn', () => syncPaymentOperationColumn($container));
    syncPaymentOperationColumn($container);
  });
};

const initializePaymentCustomerSearch = () => {
  $('.payment-customer-select').each(function () {
    const $select = $(this);
    if ($select.hasClass('select2-hidden-accessible')) return;

    $select.select2({
      theme: 'bootstrap',
      width: '100%',
      allowClear: true,
      placeholder: $select.data('placeholder'),
      minimumInputLength: 1,
      language: paymentCustomerSelectLanguage,
      ajax: {
        url: '/payment_reconciliations/customers',
        dataType: 'json',
        delay: 250,
        data: (params) => ({ q: params.term || '' }),
        processResults: (data) => data,
        cache: true,
      },
    });
  });
};

const paymentBankAccountOptionTemplate = (option) => {
  const text = option.text || '';
  return $('<span>')
    .addClass('payment-bank-account-option')
    .attr('title', text)
    .text(text);
};

const initializePaymentBankAccountSelect = () => {
  const selectors = [
    '#payment-bank-account-id',
    '#payment-bank-filter',
    '#report-bank-filter',
  ];

  const $selects = $(selectors.join(', '));
  if (!$selects.length || !$.fn.select2) return;

  $selects.each(function () {
    const $select = $(this);

    if ($select.hasClass('select2-hidden-accessible')) {
      $select.select2('destroy');
    }

    $select.find('option').each(function () {
      $(this).attr('title', $(this).text());
    });

    const select2Options = {
      width: '100%',
      theme: 'bootstrap',
      placeholder: $select.find('option[value=""]').text() || '選択してください',
      allowClear: true,
      templateResult: paymentBankAccountOptionTemplate,
      templateSelection: paymentBankAccountOptionTemplate,
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },
    };

    if ($select.closest('#payment-registration-modal').length) {
      select2Options.dropdownParent = $('#payment-registration-modal');
    }

    $select.select2(select2Options);
    $select.next('.select2-container').addClass('payment-bank-account-select2');
  });
};

const setBankAccountSelectDisabled = (disabled) => {
  const $bankSelect = $('#payment-bank-account-id');
  $bankSelect.prop('disabled', disabled);

  if (!$bankSelect.hasClass('select2-hidden-accessible')) return;

  const $container = $bankSelect.next('.select2-container');
  $container.toggleClass('select2-container--disabled', disabled);
  $container.find('.select2-selection')
    .attr('aria-disabled', disabled ? 'true' : 'false')
    .attr('tabindex', disabled ? '-1' : '0');

  if (disabled) {
    $bankSelect.select2('close');
  }
};

const updateBankAccountRequirement = () => {
  const $bankSelect = $('#payment-bank-account-id');

  if ($('#payment-single-registration-fields').hasClass('d-none')) {
    $bankSelect.prop('required', false);
    $('#payment-bank-required').addClass('d-none');
    setBankAccountSelectDisabled(true);
    return;
  }

  const method = $('#payment-payment-method').val();
  const required = bankRequiredMethods.includes(method);

  if (!required && $bankSelect.val()) {
    $bankSelect.val('').trigger('change');
  }

  $bankSelect.prop('required', required);
  $('#payment-bank-required').toggleClass('d-none', !required);
  setBankAccountSelectDisabled(!required);
};

const filterBankAccounts = (mainCompanyId) => {
  const $bankSelect = $('#payment-bank-account-id');
  $bankSelect.find('option').each(function () {
    const $option = $(this);
    if (!$option.val()) {
      $option.prop('disabled', false);
      return;
    }

    const ids = String($option.data('main-company-ids') || '').split(',');
    $option.prop('disabled', !ids.includes(String(mainCompanyId)));
  });
  $bankSelect.val('').trigger('change');
};

const setSingleRegistrationValues = (item) => {
  $('#payment-payment-method').val(item.billPayMethod);
  filterBankAccounts(item.mainCompanyId);
  updateBankAccountRequirement();

  if (
    bankRequiredMethods.includes(item.billPayMethod) &&
    item.bankAccountId &&
    !$('#payment-bank-account-id option[value="' + item.bankAccountId + '"]').prop('disabled')
  ) {
    $('#payment-bank-account-id').val(item.bankAccountId).trigger('change');
  }
};

const configureRegistrationMode = (items) => {
  const multiple = items.length > 1;
  $('#payment-single-registration-fields').toggleClass('d-none', multiple);
  $('#payment-multiple-registration-notice').toggleClass('d-none', !multiple);
  $('.payment-entry-source-column').toggleClass('d-none', !multiple);

  if (multiple) {
    $('#payment-payment-method').prop('required', false).val('');
    $('#payment-bank-account-id').val('').trigger('change');
    updateBankAccountRequirement();
    return;
  }

  if (items.length === 1) {
    $('#payment-payment-method').prop('required', true);
    setSingleRegistrationValues(items[0]);
    return;
  }

  $('#payment-payment-method').prop('required', false).val('');
  $('#payment-bank-account-id').val('').trigger('change');
  updateBankAccountRequirement();
};

const updateRegistrationSummary = () => {
  const $rows = $('#payment-registration-entries tr');
  const total = $('.payment-entry-amount').toArray().reduce((sum, input) => {
    return sum + parseAmount($(input).val());
  }, 0);

  $('#payment-registration-count').text($rows.length);
  $('#payment-registration-total').text(formatYen(total));
  $('#payment-registration-submit').prop('disabled', $rows.length === 0);
};

const resizePaymentEntryNote = (element) => {
  if (!element) return;

  element.style.height = '38px';
  const nextHeight = Math.min(element.scrollHeight, 150);
  element.style.height = `${Math.max(nextHeight, 38)}px`;
  element.style.overflowY = element.scrollHeight > 150 ? 'auto' : 'hidden';
};

const appendRegistrationEntry = (item, multiple) => {
  const $entryRow = $('<tr>').attr('data-bill-sheet-id', item.id);

  $('<td>').addClass('text-center').text(item.billNo || '-').appendTo($entryRow);
  $('<td>').addClass('text-start').text(item.customer || '-').appendTo($entryRow);
  $('<td>').addClass('text-start').text(item.project || '-').appendTo($entryRow);
  if (multiple) {
    $('<td>')
      .addClass('text-center payment-entry-source-column')
      .text(item.billPayMethodLabel || '-')
      .appendTo($entryRow);
    $('<td>')
      .addClass('text-start payment-entry-source-column')
      .text(item.bankAccountName || '未設定')
      .appendTo($entryRow);
  }
  $('<td>')
    .addClass('text-end')
    .text(formatYen(item.outstandingAmount))
    .appendTo($entryRow);

  const initialAmount = item.amount === undefined ? item.outstandingAmount : item.amount;
  const $amountInput = $('<input>')
    .attr({
      type: 'text',
      name: 'payment[entries][][amount]',
      inputmode: 'numeric',
      autocomplete: 'off',
      required: true,
      'data-max': item.outstandingAmount,
    })
    .addClass('form-control text-end payment-entry-amount')
    .val(formatAmount(initialAmount));
  updateAmountValidity($amountInput.get(0), parseAmount(initialAmount));
  const $billIdInput = $('<input>').attr({
    type: 'hidden',
    name: 'payment[entries][][bill_sheet_id]',
    value: item.id,
  });
  $('<td>').addClass('text-end').append($billIdInput, $amountInput).appendTo($entryRow);

  const $noteInput = $('<textarea>')
    .attr({
      name: 'payment[entries][][note]',
      rows: 1,
    })
    .addClass('form-control payment-entry-note')
    .val(item.note || '');
  $('<td>').addClass('text-start payment-entry-note-cell').append($noteInput).appendTo($entryRow);

  const $removeButton = $('<button>')
    .attr({
      type: 'button',
      title: '選択解除',
      'aria-label': '選択解除',
    })
    .addClass('btn btn-outline-secondary payment-entry-remove')
    .append($('<i>').addClass('fas fa-times').attr('aria-hidden', 'true'));
  $('<td>').addClass('text-center').append($removeButton).appendTo($entryRow);
  $('#payment-registration-entries').append($entryRow);
  resizePaymentEntryNote($noteInput.get(0));
};

const renderPaymentRegistration = (items) => {
  const multiple = items.length > 1;
  configureRegistrationMode(items);
  $('#payment-registration-entries').empty();
  items.forEach((item) => appendRegistrationEntry(item, multiple));
  updateRegistrationSummary();
};

const openPaymentRegistration = () => {
  const items = Array.from(selectedPaymentItems.values());
  if (!items.length) {
    showPaymentError('入金対象を選択してください。');
    return;
  }

  const mainCompanyIds = [...new Set(items.map((item) => item.mainCompanyId))];
  if (mainCompanyIds.includes('')) {
    showPaymentError('対象請求の部署にグループ会社が設定されていません。');
    return;
  }
  if (mainCompanyIds.length !== 1) {
    showPaymentError('異なるグループ会社の請求は分けて登録してください。');
    return;
  }

  if (items.some((item) => !item.billPayMethod)) {
    showPaymentError('請求方法が未設定の請求は、請求書を修正してから登録してください。');
    return;
  }

  items.forEach((item) => {
    item.amount = item.outstandingAmount;
  });
  renderPaymentRegistration(items);
  $('#payment-registration-modal').modal('show');
};

const initializePaymentDatePickers = () => {
  $('.payment-date-input.singledate').each(function () {
    const $input = $(this);
    const picker = $input.data('daterangepicker');
    const value = $input.val();
    if (!picker || !value) return;

    picker.setStartDate(value);
    picker.setEndDate(value);
  });
};

$(document).ready(() => {
  initializePaymentCustomerSearch();
  initializePaymentBankAccountSelect();
  initializePaymentOperationColumn();
  initializePaymentDatePickers();
  updatePaymentSelectionUI();
  updateBankAccountRequirement();
});

$(window)
  .off('resize.paymentOperationColumn')
  .on('resize.paymentOperationColumn', initializePaymentOperationColumn);

$(document).on('change', '.payment-bill-checkbox', function () {
  const $row = $(this).closest('.payment-bill-row');
  const item = rowPaymentItem($row);
  if ($(this).prop('checked')) {
    selectedPaymentItems.set(item.id, item);
  } else {
    selectedPaymentItems.delete(item.id);
  }
  updatePaymentSelectionUI();
});

$(document).on('change', '#payment_check_all', function () {
  paymentSelectionScope = 'page';
  selectedPaymentItems.clear();
  if ($(this).prop('checked')) {
    $('.payment-bill-checkbox:not(:disabled)').each(function () {
      const item = rowPaymentItem($(this).closest('.payment-bill-row'));
      selectedPaymentItems.set(item.id, item);
    });
  }
  updatePaymentSelectionUI();
});

$(document).on('click', '#select-all-filtered-payments', function () {
  const $button = $(this);
  const selectionUrl = $('#payment-selection-scope').attr('data-selection-url');
  $button.prop('disabled', true);

  $.getJSON(selectionUrl)
    .done((response) => {
      selectedPaymentItems.clear();
      (response.items || []).forEach((rawItem) => {
        const item = normalizeSelectionItem(rawItem);
        selectedPaymentItems.set(item.id, item);
      });
      paymentSelectionScope = 'filtered';
      updatePaymentSelectionUI();
    })
    .fail(() => {
      showPaymentError('検索結果の取得に失敗しました。画面を更新して再度お試しください。');
    })
    .always(() => {
      $button.prop('disabled', false);
    });
});

$(document).on('click', '#clear-payment-selection', clearPaymentSelection);
$(document).on('click', '#open-payment-registration', openPaymentRegistration);
$(document).on('click', '#payment-report-print', () => window.print());

$(document).on('change', '#payment-payment-method', updateBankAccountRequirement);

$(document).on('click', '.payment-entry-remove', function () {
  const $row = $(this).closest('tr');
  selectedPaymentItems.delete(String($row.attr('data-bill-sheet-id')));
  updatePaymentSelectionUI();
  renderPaymentRegistration(Array.from(selectedPaymentItems.values()));
});

$(document).on('input', '.payment-entry-amount', function () {
  const input = this;
  const previousValue = input.value;
  const previousCaret = input.selectionStart;
  const formattedValue = formatAmount(previousValue);
  if (previousValue !== formattedValue) {
    input.value = formattedValue;
    restoreAmountCaret(input, previousValue, previousCaret, formattedValue);
  }

  const amount = parseAmount(formattedValue);
  const $row = $(this).closest('tr');
  const item = selectedPaymentItems.get(String($row.attr('data-bill-sheet-id')));
  if (item) item.amount = amount;
  updateAmountValidity(input, amount);
  updateRegistrationSummary();
});

$(document).on('input', '.payment-entry-note', function () {
  resizePaymentEntryNote(this);
  const $row = $(this).closest('tr');
  const item = selectedPaymentItems.get(String($row.attr('data-bill-sheet-id')));
  if (item) item.note = $(this).val();
});

$(document).on('submit', '#payment-registration-form', function (event) {
  updateBankAccountRequirement();
  const $bankSelect = $('#payment-bank-account-id');
  if ($bankSelect.prop('required') && !$bankSelect.val()) {
    event.preventDefault();
    showPaymentError('入金先口座を選択してください。');
    return;
  }

  $('#payment-registration-submit').prop('disabled', true);
});
